module.exports = __webpack_public_path__ + "static/section-one-a0635dc917cbf452dfb9de1dfc8e575c.png";